function toggleDropdown(btn, dropdown, shouldOpen) {
  const menuItems = dropdown.querySelectorAll('a');

  btn.setAttribute('aria-expanded', shouldOpen);
  dropdown.setAttribute('aria-hidden', !shouldOpen);
  dropdown.classList.toggle('is-open', shouldOpen);

  menuItems.forEach(item => {
    item.setAttribute('tabindex', shouldOpen ? '0' : '-1');
  });
}

const initShare = () => {
  const shareComponents = document.querySelectorAll('.social-share');

  if (shareComponents.length === 0) return;

  // Guard: Cookiebot re-executes main.js after the consent decision even when the script
  // has data-cookieconsent="ignore". Ensure only one document click handler is ever added.
  if (document.body.shareInit) return;
  document.body.shareInit = true;

  // Delegated click handler
  document.addEventListener('click', (e) => {
    if (!e.isTrusted) return;

    const btn = e.target.closest('.social-share .btn');

    if (btn) {
      e.preventDefault();
      e.stopPropagation();

      const share    = btn.closest('.social-share');
      const dropdown = share ? share.querySelector('.share-dropdown') : null;

      if (!share || !dropdown) return;

      const isActive = btn.getAttribute('aria-expanded') === 'true';
      toggleDropdown(btn, dropdown, !isActive);
      return;
    }

    if (!e.target.closest('.social-share')) {
      document.querySelectorAll('.social-share').forEach(share => {
        const shareBtn      = share.querySelector('.btn');
        const shareDropdown = share.querySelector('.share-dropdown');
        if (!shareBtn || !shareDropdown) return;
        toggleDropdown(shareBtn, shareDropdown, false);
      });
    }
  });

  // Keyboard listeners per element
  document.querySelectorAll('.social-share').forEach(share => {
    const btn      = share.querySelector('.btn');
    const dropdown = share.querySelector('.share-dropdown');

    if (!btn || !dropdown) return;
    if (btn.shareInit) return;
    btn.shareInit = true;

    const menuItems = dropdown.querySelectorAll('a');

    btn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopPropagation();
        const isActive = btn.getAttribute('aria-expanded') === 'true';
        toggleDropdown(btn, dropdown, !isActive);
      } else if (e.key === 'ArrowDown' && btn.getAttribute('aria-expanded') !== 'true') {
        e.preventDefault();
        toggleDropdown(btn, dropdown, true);
        if (menuItems.length > 0) menuItems[0].focus();
      } else if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
        e.preventDefault();
        toggleDropdown(btn, dropdown, false);
        btn.focus();
      }
    });

    dropdown.addEventListener('keydown', (e) => {
      const currentIndex = Array.from(menuItems).indexOf(document.activeElement);

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          menuItems[(currentIndex + 1) % menuItems.length].focus();
          break;
        case 'ArrowUp':
          e.preventDefault();
          menuItems[currentIndex <= 0 ? menuItems.length - 1 : currentIndex - 1].focus();
          break;
        case 'Escape':
          e.preventDefault();
          toggleDropdown(btn, dropdown, false);
          btn.focus();
          break;
        case 'Home':
          e.preventDefault();
          menuItems[0].focus();
          break;
        case 'End':
          e.preventDefault();
          menuItems[menuItems.length - 1].focus();
          break;
      }
    });
  });

};

export default initShare;
